import React from "react";

const ServicesSection = () => {
  const services = [
    "Toner Only Long – A$245",
    "Tint Semi Long – A$210",
    "Face Frame – A$250",
  ];

  return (
    <>
      <h2 className="text-3xl font-bold mb-6">Services</h2>
      <ul className="space-y-4">
        {services.map((service, idx) => (
          <li
            key={idx}
            className="p-4 border rounded hover:shadow transition cursor-pointer"
          >
            {service}
          </li>
        ))}
      </ul>
    </>
  );
};

export default ServicesSection;
